import { createStructuredSelector, createSelector } from 'reselect'
import { get, find } from 'lodash';

export const newBatteries = state => state.dashboard.newBatteriesLastMonth

export const sites = ({ siteManager }) => siteManager.getIn(['rootSitesById'], []);

export const data = createSelector(
  [newBatteries, sites],
  (avgBatHp,sites) => avgBatHp.getIn(['batteryList'], []).map((row, index) =>
  {
      return {
        serialNumber: row.serialNumber,
        currentDevice: row.currentDevice,
        currentDeviceAlias: row.currentDeviceAlias,
        batterySite: get(find(sites, { value: row.batterySite }), 'text', ''),
        lastUpdated: row.lastUpdated
      };   
  })  
)

export default createStructuredSelector({
  data
})
